const config = {
  API_URL: process.env.REACT_APP_API_URL,
  // FILE_MICROSERVICE_URL: process.env.FILE_MICROSERVICE_URL,
  AUTH_FRONTEND_URL: process.env.REACT_APP_AUTH_FRONTEND_URL,
  AUTH_BACKEND_URL: process.env.REACT_APP_AUTH_BACKEND_URL,
  REACT_APP_LOCAL_DEV: process.env.REACT_APP_LOCAL_DEV === 'true' ? true : false // if true then auth token must be sent
};

export default config;
